<template>
  <layout-default-appbar :back-to="rotacadastro">
    Origem
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';

import { ROUTE_CADASTRO } from '@/constants/ROUTES';

export default {
  name: 'ViewOrigemAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  data() {
    return {
      rotacadastro: ROUTE_CADASTRO,
    };
  },
};
</script>
